var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2020, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useCallback, Fragment } from 'react';
import styled from '../../../../styles/styled';
import { Select } from '../../../Select/Select';
const TotalPages = styled('span') `
  margin-left: ${(p) => p.theme.spacings.kilo};
`;
export const PageSelect = (_a) => {
    var { label, onChange, pages, currentPage, totalPages, totalLabel } = _a, props = __rest(_a, ["label", "onChange", "pages", "currentPage", "totalPages", "totalLabel"]);
    const pageOptions = pages.map((value) => ({ value, label: `${value}` }));
    const handleChange = useCallback((event) => {
        onChange(parseInt(event.target.value, 10));
    }, [onChange]);
    return (_jsxs(Fragment, { children: [_jsx(Select, Object.assign({}, props, { label: label, value: currentPage, options: pageOptions, onChange: handleChange, hideLabel: true })), totalLabel && _jsx(TotalPages, { children: totalLabel(totalPages) })] }));
};
